import IObject from 'Types/Standards/IObject';

function enumToArray(enumme: IObject): string[] {
  return Object.keys(enumme).map(key => enumme[key]);
}

export default enumToArray;
